var React = require('react');

function StarEmptyInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"m9 1.277 2.072 4.87 5.273.467-3.992 3.475 1.186 5.159L9 12.525l-4.54 2.723 1.187-5.159-3.992-3.475 5.273-.466L9 1.278Z","stroke":"currentColor","fill":"none","fillRule":"evenodd"}));
}

StarEmptyInline.defaultProps = {"width":"18","height":"17"};

module.exports = StarEmptyInline;

StarEmptyInline.default = StarEmptyInline;
